import { request } from "@/utils/request";
//get 请求
export const szkGet = (params = {}, url) => {
    return request({
        url,
        method: "get",
        params
    });
};
//post 请求
export const szkPost = (data = {}, url) => {
    return request({
        url,
        method: "post",
        data
    });
};
//put 请求
export const szkPut = (data = {}, url) => {
    return request({
        url,
        method: "put",
        data
    });
};
//put 请求
export const szkDelete = (data = {}, url) => {
    return request({
        url,
        method: "delete",
        data
    });
};
